import { array, object, string, number } from "yup";

let createTaskSchema = object({
  title: string().required("Title cannot be empty."),
  website: string().required("Website cannot be empty."),
  priority: number().required("Priority cannot be empty."),
  status: number().required("Status cannot be empty."),
  due_date: string().required("Completion date cannot be empty."),
  webmaster: array().min(1, "Webmaster cannot be empty."),
  finished_when: string().required("Task description cannot be empty."),
});

export default createTaskSchema;
